export const smartButtonIcons = [
  {
    iconClass: 'sub_icon primeNG pi pi-amazon',
    name: 'Amazon'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-android',
    name: 'Android'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-apple',
    name: 'Apple'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-at',
    name: 'Chiocciola'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-ban',
    name: 'Divieto'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-bars',
    name: 'Elenco'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-bell',
    name: 'Campanella'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-bitcoin',
    name: 'Bitcoin'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-bolt',
    name: 'Flash'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-arrow-circle-down',
    name: 'Freccia in basso'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-arrow-circle-left',
    name: 'Freccia a sinistra'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-arrow-circle-right',
    name: 'Freccia a destra'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-arrow-circle-up',
    name: 'Freccia in alto'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-backward',
    name: 'Indietro'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-book',
    name: 'Libro'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-box',
    name: 'Scatola'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-briefcase',
    name: 'Valigia'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-building',
    name: 'Palazzo'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-calculator',
    name: 'Calcolatrice'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-calendar',
    name: 'Calendario'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-camera',
    name: 'Fotocamera'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-car',
    name: 'Auto'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-chart-bar',
    name: 'Grafico a barre'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-chart-line',
    name: 'Grafico a linea'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-chart-pie',
    name: 'Grafico a torta'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-check-circle',
    name: 'Flag'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-circle-fill',
    name: 'Cerchio'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-clock',
    name: 'Orologio'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-clone',
    name: 'Copia'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-cloud',
    name: 'Nuvola'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-cloud-download',
    name: 'Download'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-cloud-upload',
    name: 'Upload'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-cog',
    name: 'Ingranaggio'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-comment',
    name: 'Messaggio'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-comments',
    name: 'Messaggi'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-compass',
    name: 'Bussola'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-credit-card',
    name: 'Carta di credito'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-database',
    name: 'Database'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-desktop',
    name: 'Monitor'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-envelope',
    name: 'Busta'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-eraser',
    name: 'Gomma'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-euro',
    name: 'Euro'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-exclamation-triangle',
    name: 'Errore'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-external-link',
    name: 'Link'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-eye',
    name: 'Occhio'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-file',
    name: 'File'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-file-excel',
    name: 'Excel'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-file-pdf',
    name: 'Pdf'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-file-word',
    name: 'Word'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-filter',
    name: 'Filtro'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-flag',
    name: 'Bandiera'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-folder',
    name: 'Cartella 1'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-folder-open',
    name: 'Cartella 2'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-gift',
    name: 'Regalo'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-globe',
    name: 'Mondo'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-hashtag',
    name: 'Hashtag'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-heart',
    name: 'Cuore'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-home',
    name: 'Casa'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-hourglass',
    name: 'Clessidra'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-id-card',
    name: 'Carta identità'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-images',
    name: 'Immagini'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-key',
    name: 'Chiave'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-link',
    name: 'Collegamento'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-lock',
    name: 'Lucchetto'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-map',
    name: 'Mappa'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-megaphone',
    name: 'Megafono'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-microphone',
    name: 'Microfono'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-microsoft',
    name: 'Microsoft'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-mobile',
    name: 'Smartphone'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-money-bill',
    name: 'Banconota'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-moon',
    name: 'Luna'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-paperclip',
    name: 'Allegato'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-phone',
    name: 'Telefono'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-print',
    name: 'Stampante'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-qrcode',
    name: 'QrCode'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-server',
    name: 'Server'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-send',
    name: 'Invio'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-sitemap',
    name: 'Organigramma'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-star',
    name: 'Stella'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-stopwatch',
    name: 'Timer'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-sun',
    name: 'Sole'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-tag',
    name: 'Tag'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-ticket',
    name: 'Ticket'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-truck',
    name: 'Camion'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-trash',
    name: 'Cestino'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-user',
    name: 'Utente'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-wallet',
    name: 'Portafoglio'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-bookmark',
    name: 'Segnalibro'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-cart-plus',
    name: 'Carrello'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-code',
    name: 'Codice'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-copy',
    name: 'Copia'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-info-circle',
    name: 'Informazioni'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-language',
    name: 'Lingua'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-percentage',
    name: 'Percentuale'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-question-circle',
    name: 'Domanda'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-search',
    name: 'Cerca'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-share-alt',
    name: 'Condividi'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-shield',
    name: 'Scudo'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-sync',
    name: 'Sincronizzazione'
  },
  {
    iconClass: 'sub_icon primeNG pi pi-tablet',
    name: 'Tablet'
  },
  {
    iconClass: 'sub_icon fa fa-address-book',
    name: 'Rubrica'
  },
  {
    iconClass: 'sub_icon fa fa-bandcamp',
    name: 'Bussola'
  },
  {
    iconClass: 'sub_icon fa fa-free-code-camp',
    name: 'Fuoco'
  },
  { iconClass: 'sub_icon fa fa-podcast', name: 'Podcast' },
  { iconClass: 'sub_icon fa fa-ravelry', name: 'Ravelry' },
  { iconClass: 'sub_icon fa fa-superpowers', name: 'Superpoteri' },
  { iconClass: 'sub_icon fa fa-thermometer-full', name: 'TermometroPieno' },
  { iconClass: 'sub_icon fa fa-bug', name: 'Insetto' },
  { iconClass: 'sub_icon fa fa-cube', name: 'Cubo' },
  { iconClass: 'sub_icon fa fa-cubes', name: 'Cubi' },
  { iconClass: 'sub_icon fa fa-database', name: 'Database' },
  { iconClass: 'sub_icon fa fa-deaf', name: 'Sordo' },
  { iconClass: 'sub_icon fa fa-diamond', name: 'Diamante' },
  { iconClass: 'sub_icon fa fa-eraser', name: 'Gomma' },
  { iconClass: 'sub_icon fa fa-flag', name: 'Bandiera' },
  { iconClass: 'sub_icon fa fa-futbol-o', name: 'Calcio' },
  { iconClass: 'sub_icon fa fa-university', name: 'Università' },
  { iconClass: 'sub_icon fa fa-leaf', name: 'Foglia' },
  { iconClass: 'sub_icon fa fa-life-ring', name: 'Salvagente' },
  { iconClass: 'sub_icon fa fa-magic', name: 'Magia' },
  { iconClass: 'sub_icon fa fa-puzzle-piece', name: 'PezzoDiPuzzle' },
  { iconClass: 'sub_icon fa fa-road', name: 'Strada' },
  { iconClass: 'sub_icon fa fa-ship', name: 'Nave' },
  { iconClass: 'sub_icon fa fa-space-shuttle', name: 'NavicellaSpaziale' },
  { iconClass: 'sub_icon fa fa-tachometer', name: 'Tachimetro' },
  { iconClass: 'sub_icon fa fa-tint', name: 'Goccia' },
  { iconClass: 'sub_icon fa fa-user-plus', name: 'UtentePiù' },
  { iconClass: 'sub_icon fa fa-user-times', name: 'UtenteMeno' },
  { iconClass: 'sub_icon fa fa-universal-access', name: 'AccessoUniversale' },
  { iconClass: 'sub_icon fa fa-gitlab', name: 'Gitlab' },
  { iconClass: 'sub_icon primeNG pi pi-file-plus', name: 'File Aggiungi' },
  { iconClass: 'sub_icon primeNG pi pi-file-edit', name: 'File Modifica' },

]
